<template>
  <v-card>
    <v-form @submit.prevent="saveQuotation()" ref="form" :disabled="isSaving || !isEdit">
      <v-card-text class="px-4 py-4 mb-2">
        <v-row>
          <v-col cols="6">
            <h1 class="d-inline me-5">
              {{ $t('bill.quotation') }}
              <!-- <span class="text-xs"
                >({{ formData.documentTypeString || documentTypeString }})</span
              >-->
            </h1>
            <br />
            <h2 class="d-inline me-5" v-if="formData && formData.documentId">
              {{ formData.documentId }}
              <!-- <v-badge right color="error" class="ml-3">
                <span slot="badge">ค้างชำระ</span>
              </v-badge>-->
            </h2>
          </v-col>
          <v-col cols="6" class="mt-2 text-right" v-if="formData">
            <v-btn color="default" elevation="2" outlined class="mx-2 my-1" @click="dismiss()"
              :disabled="isSaving">{{ $t('close_window') }}</v-btn>
            <template v-if="!isLoading">
              <v-btn v-show="!isEdit" color="info" elevation="2" class="mx-2 my-1" @click="isPrintDialog = true"
                :disabled="isSaving || isLoading">
                <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('payment.print_quotation') }}
              </v-btn>
              <v-btn v-show="isEdit" color="success" elevation="2" class="mx-2 my-1" type="submit"
                :disabled="isSaving || isLoading">
                <v-icon dark class="me-2">mdi-content-save-all</v-icon>{{ $t('save') }}
              </v-btn>
              <v-btn v-if="!isEdit && isCanEdit" color="orange" elevation="2" class="mx-2 my-1 white--text"
                @click="isEdit = true" type="button" :disabled="isSaving || isLoading">
                <v-icon dark class="me-2">mdi-clipboard-edit-outline</v-icon>{{ $t('action_type.edit') }}
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card elevation="3" class="pt-5 mx-5 ps-5" v-if="!isLoading">
        <div class="card-receipt-form">
          <div class="mb-10 pe-5">
            <v-row>
              <v-col cols="12" sm="12" md="5" lg="3">
                <span>
                  <b>{{ $t('customer.company_name_and_customer_name') }}</b>
                </span>
                <v-text-field v-model="formData.customerData.name" :rules="[rules.required]"
                  :placeholder="$t('customer.company_name_and_customer_name')" class="mb-4 input-disable" outlined dense
                  hide-details></v-text-field>
                <p class="mb-3">
                  <b>{{ $t('detail') }}</b>
                </p>
                <v-textarea v-model="formData.customerData.address" :placeholder="$t('address.address_detail')"
                  :label="$t('address.address_detail')" class="mb-2" outlined dense hide-details rows="2" no-resize></v-textarea>

                <v-row no-gutters>
                  <v-col cols="6">
                    <v-text-field v-model="formData.customerData.branchName"
                      :class="`mb-1 ${formData.customerData.taxId ? 'mt-9' : 'mt-9'}`" :placeholder="$t('address.company_branch')"
                      :label="$t('address.company_branch')" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="6" class="ps-1">
                    <EditTaxId :getLabel="$t('tax.tax_id_number')" v-model='formData.customerData.taxId'
                      :customClassLabel="'d-block mb-3'" :customClassWarning="'mb-2'" showWarning :showLabel='false'
                      :getIsVat="customerType == 'company' ? true : false"
                      :getIsExport="customerType == 'company' && isEdit ? true : false" showPlaceholder
                      :customClassInput="'mb-2'" :solo='false' :flat='false' outlined dense :counter='false'
                      :getRules="rules" @onWriteData="onWriteData" @input="formData.customerData.taxId = $event" />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="formData.customerData.tel" class="mb-2" :placeholder="$t('account.phone_number')"
                      :label="$t('account.phone_number')" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="6" class="ps-1">
                    <v-text-field v-model="formData.customerData.email" class="mb-2" placeholder="Email" label="Email"
                      outlined dense hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col></v-col>

              <v-col cols="12" sm="12" md="5" lg="3">
                <p class="mb-0">
                  <b>{{ $t('payment.total_amount_all_payment') }}</b>
                </p>
                <h1 class="mb-7">
                  {{ formData.totalValue | currencySuffixTextThEn(formData.currencyCode) }}
                  <h4 class="d-inline red--text" v-if="formData.totalUnpaidValue">{{ $t('payment.remaining') }} {{ formData.totalUnpaidValue | currencySuffixTextThEn(formData.currencyCode) }}</h4>
                </h1>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('date') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(quotationDate)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="quotationDate" no-title locale="th" @input="onChangeDate()"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('due_date') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-menu v-model="menuDueDate" :close-on-content-click="false" transition="scale-transition" offset-y
                      max-width="290px" min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="$helper.datelabel(quotationDueDate)" :placeholder="$t('date')" outlined dense
                          hide-details readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="quotationDueDate" no-title locale="th" @input="menuDueDate = false"
                        :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                        :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 3px; padding-bottom: 8px;" v-if="isErrorCreditTerm">
                  <v-col cols="4"></v-col>
                  <v-col cols="8" class="py-0 text-center">
                    <small class="warning--text">
                      <v-icon small color="warning" style="margin-top: -3px;">mdi-alert-outline</v-icon>
                      {{ $t('payment.credit_term_is', { creditTerm: creditTerm }) }}
                    </small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('project.employee') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-text-field :placeholder="$t('project.employee')" outlined dense hide-details :value="userFullName" readonly
                      disabled></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('payment.currency') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-select v-model="formData.currencyCode" :items="$helper.currencyOptions" item-text="value" item-value="value"
                      outlined dense hide-details disabled :no-data-text="$t('noinfo')"></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr class="my-5" />
            <v-row class="mb-0">
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-subheader>
                      <b>{{ $t('product.product_price') }}:</b>
                    </v-subheader>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-select v-model="formData.isVatInclusive" :placeholder="$t('product.product_price')" :items="[
                      {
                        text: this.$t('payment.price_vat_exclusive'),
                        value: false,
                      },
                      {
                        text: this.$t('payment.price_vat_inclusive'),
                        value: true,
                      },
                    ]" item-text="text" item-value="value" @change="onChangeIsVatInclusive()" outlined dense
                      hide-details :no-data-text="$t('noinfo')"></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div style="border-radius: 10px; overflow: hidden">
              <v-simple-table v-if="formData.items && formData.items.length">
                <template v-slot:default>
                  <thead class="table-item header rounded-2">
                    <tr>
                      <th width="3%" class="text-center">{{ $t('rank') }}</th>
                      <th>{{ $t('product.product_name_and_detail') }}</th>
                      <th width="8%">{{ $t('area.space') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.quantity') }}</th>
                      <th width="8%">{{ $t('unit') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.unit_price') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.discount_unit') }}</th>
                      <th width="8%">{{ $t('product.vat') }}</th>
                      <th width="8%">{{ $t('accounting_product.withholding_tax') }}</th>
                      <th width="8%" class="text-right">{{ $t('product.total_price') }}</th>
                      <th width="4%" class="text-center" v-if="isEdit"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in formData.items" :key="index">
                      <td class="py-2 text-center vertical-top">{{ index + 1 }}</td>
                      <td class="py-2">
                        <v-text-field v-if="item.billingSetting" v-model="item.name" :placeholder="$t('product.product_name')" outlined
                          dense hide-details disabled></v-text-field>
                        <v-autocomplete v-else v-model="item.name" :placeholder="$t('product.product_name')"
                          :items="accountingProductOptions" :rules="[rules.required]" item-text="text" item-value="text"
                          outlined dense hide-details :menu-props="{ closeOnContentClick: true }"
                          :error="isDuplicateItem(item)">
                          <template v-slot:no-data>
                            <v-list-item class="d-flex justify-center">{{ $t('bill.no_bill_list') }}</v-list-item>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item v-if="item.isAddProduct">
                              <v-list-item-title>
                                <v-btn text color="green" block link @click="addProduct()">
                                  <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('accounting_product.add') }}
                                </v-btn>
                              </v-list-item-title>
                            </v-list-item>
                            <template v-else>
                              <v-list-item @click="chooseItem(item.obj, index)" v-show="!item.obj.isRemoved">{{ item.text
                              }}</v-list-item>
                            </template>
                          </template>
                        </v-autocomplete>
                        <template v-if="!formData.isSent && !item.billingSetting && isDuplicateItem(item)">
                          <p class="mb-1"><small class="red--text">{{ $t('area.have_bill_and_stall') }}</small></p>
                        </template>
                        <v-text-field v-model="item.detail" :placeholder="$t('detail')" outlined dense hide-details
                          value="detail"></v-text-field>
                      </td>
                      <!-- vuetify area select -->
                      <td class="py-2 vertical-top">
                        <v-select :no-data-text="$t('noinfo')" :disabled="item.billingSetting && item.area ? true : false" v-model="item.area" :items="[
                          { isRemove: true, name: '-' },
                          ...quotationAreas,
                        ]" :item-text="(i) => (i.isRemove ? '-' : `${i.name} (${i.size || '-'}${$t('square_meter')})`)" :item-value="(r) =>
  r.isRemove
    ? { isRemove: true }
    : {
      className: 'Area',
      objectId: r.objectId,
      __type: 'Pointer',
    }
  " outlined dense hide-details @change="chooseArea(index)" :error="isDuplicateItem(item)">
                          <template v-slot:selection="{ item }">
                            <div class="d-block w-100" style="width: 100%">
                              <v-btn text v-if="item.isRemove">-</v-btn>
                              <template v-else>
                                <div class="d-block w-100">{{ item.name }}</div>
                                <div class="d-block w-100 text-right text-gray" style="font-size: 13px">{{ `${item.size ||
                                  '-'}${$t('square_meter')}` }}</div>
                              </template>
                            </div>
                          </template>
                        </v-select>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field 
                          :placeholder="$t('product.quantity')" 
                          class="input-right input-disable-appearance" outlined dense
                          hide-details v-model="item.quantity" 
                          @input="(value) =>(item.quantity = parseFloat(item.quantity))"
                          :rules="[rules.required]"
                        />
                      </td>
                      <td class="py-2 vertical-top">
                        <v-text-field v-model="item.unit" :placeholder="$t('unit')" outlined dense hide-details :value="$t('product.box')"
                          :rules="[rules.required]"></v-text-field>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-currency-field 
                          v-model="item.originalPricePerUnit"
                          :placeholder="$t('product.unit_price')"
                          class="input-right input-disable-appearance" outlined dense hide-details
                          @input="(value) => (item.originalPricePerUnit = parseFloat(item.originalPricePerUnit))"
                          :rules="item.type == 'discount' ? [] : [rules.required]"
                          :disabled="item.type == 'discount'"
                          :options="{ precision: {}}"
                        />
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-menu v-if="item.type != 'discount'" offset-y style="max-width: 600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-currency-field 
                              v-model="item.discountPerUnit" 
                              :placeholder="$t('product.discount_per_unit_price')"
                              class="input-right input-disable-appearance" 
                              outlined dense hide-details 
                              @input="(value) => (item.discountPerUnit = parseFloat(item.discountPerUnit))"
                              :suffix="item.discountType == 2 ? '%' : ''" 
                              v-bind="attrs" v-on="on"
                              :rules="item.discountType == 2 ? [rules.maxDiscountPercent] : []"
                            />
                          </template>
                          <v-card>
                            <v-card-title class="px-3 py-2">
                              <h5 class="my-0">{{ $t('product.select_discount_type') }}</h5>
                            </v-card-title>
                            <v-card-text class="px-4 py-0">
                              <v-radio-group v-model="item.discountType" class="my-0 py-0 small-radio" column>
                                <v-radio :label="$helper.currencyThEn(formData.currencyCode)" :value="1"></v-radio>
                                <v-radio :label="$t('percent')" :value="2"></v-radio>
                              </v-radio-group>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                        <v-currency-field v-else
                          v-model="item.discountPerUnit" 
                          :placeholder="$t('product.discount_per_unit_price')"
                          class="input-right input-disable-appearance" 
                          outlined dense hide-details 
                          @input="(value) => (item.discountPerUnit = parseFloat(item.discountPerUnit))"
                        />
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-select v-model="item.sellVatType" :items="[
                          {
                            text: `${formData.vatPercent}%`,
                            value: 1,
                          },
                          {
                            text: '0%',
                            value: 2,
                          },
                          {
                            text: $t('except'),
                            value: 3,
                          },
                        ]" item-text="text" item-value="value" :placeholder="$t('product.unit_price')" outlined dense
                          hide-details :no-data-text="$t('noinfo')"></v-select>
                      </td>
                      <td class="py-2 text-right vertical-top">
                        <v-select v-model="item.whtPercent" :items="taxWithheldOptions" item-text="name"
                          item-value="value" :placeholder="$t('product.withholding')" outlined lang hide-details :no-data-text="$t('noinfo')">
                          <template v-slot:selection="data">
                            <div class="d-block w-100" style="width: 100%">
                              <template v-if="data.item.value > 0">
                                <div class="d-block w-100">
                                  {{ item.totalWhtValue | currency }}
                                  <br />
                                </div>
                              </template>
                              <div class="d-block w-100" :style="data.item.value > 0 ? 'font-size: 13px' : ''
                                " :class="data.item.value > 0
    ? 'text-right text-gray'
    : ''
    ">{{ data.item.name }}</div>
                            </div>
                          </template>
                        </v-select>
                      </td>
                      <td class="py-4 text-right vertical-top">
                        <b>{{ item.totalOriginalValue | currency }}</b>
                      </td>
                      <td class="text-center" v-if="isEdit">
                        <v-icon class="mr-2" @click="deleteItem(index)"
                          :disabled="isSaving">mdi-trash-can-outline</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div class="px-5 py-3">
              <v-btn class="mx-2" color="primary" elevation="2" outlined @click="addItem()"
                :disabled="isSaving || !isEdit">
                <v-icon dark class="me-2">mdi-plus</v-icon>{{ $t('area.add_line_list') }}
              </v-btn>
              <v-btn class="mx-2" color="primary" elevation="2" outlined @click="isAddItemAreasDialog = true"
                :disabled="isSaving || !isEdit">
                <v-icon dark class="me-2">mdi-plus-box-multiple-outline</v-icon>{{ $t('area.add_multiple_stall') }}
              </v-btn>
            </div>
            <v-row class="px-5 mt-3 mb-0">
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <b>{{ $t('note') }}:</b>
                  </v-col>
                  <v-col cols="6" class="text-right blue--text" v-show="isEdit">
                    <span @click="isMessageTemplateDialog = true" style="cursor: pointer;">
                      <v-icon small color="blue">mdi-message-processing-outline</v-icon>{{ $t('area.add_text') }}
                    </span>
                  </v-col>
                </v-row>
                <v-textarea v-model="formData.note" :placeholder="$t('note')" outlined dense hide-details rows="2"
                  no-resize></v-textarea>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" class="pe-5">
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_amount') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalOriginalValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalDiscountValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalNonVatItemsValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatItemsValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_vat') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ formData.totalVatValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number bold">{{ formData.totalValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <div v-if="isWht">
                  <hr class="my-4" />
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic">{{ $t('tax.tax_withholding') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number">{{ formData.totalWhtValue | currencySuffixTextThEn(formData.currencyCode) }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic bold">{{ $t('payment.total_amount_to_pay') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number bold">
                        {{
                          (formData.totalValue - formData.totalWhtValue)
                          | currencySuffixTextThEn(formData.currencyCode)
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
                <hr class="mt-4" />
                <hr class="mt-1" />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
      <v-card class="justify-center py-10 d-flex" v-if="isLoading">
        <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
      </v-card>
    </v-form>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <ConfirmDialog v-model="isConfirmDialog" :title="$t('validate.you_want_to_save_data')" :textBtnOk="$t('save_and_close')"
      :textBtnCancel="$t('not_save_and_close')" @onOk="onOkConfirmDialog" @onCancel="onCancelConfirmDialog" />
    <AccountingProductManageDialog v-model="isDialogAccountingProduct" :projectId="projectId"
      @onSaveSuccess="isSuccess = true" @onError="isError = true" />
    <PrintDialog elementId="print-quotation-form" type="quotation" v-if="formData && formData.objectId"
      v-model="isPrintDialog" :quotationIds="[formData.objectId]" />
    <MessageTemplateDialog v-if="areaInterest" v-model="isMessageTemplateDialog" :projectId="projectId"
      :marketId="marketId" :areaInterest="areaInterest" @onSelectMessage="onSelectMessage" />
    <ChooseAccountingProductAndAreas v-model="isAddItemAreasDialog" :accountingProducts="accountingProducts"
      :areas="quotationAreas" @onSuccess="onSuccessChooseProductAndAreas" />
  </v-card>
</template>

<script>
import { DocumentItem, Quotation, Customer, Market } from "../classes";
import { mapState } from "vuex";
import AccountingProductManageDialog from "@/components/AccountingProductManageDialog.component";
import ConfirmDialog from "@/components/ConfirmDialog.component";
import PrintDialog from "../components/PrintDialog.component.vue";
import MessageTemplateDialog from "../components/MessageTemplateDialog.vue";
import ChooseAccountingProductAndAreas from "../components/ChooseAccountingProductAndAreas.vue";
import EditTaxId from "@/components/EditTaxId.vue";

export default {
  props: {
    type: String, // require
    areaInterestId: String, // require
    projectId: String, // require
    quotationId: String, //optional
    marketId: String
  },
  components: {
    AccountingProductManageDialog,
    ConfirmDialog,
    PrintDialog,
    MessageTemplateDialog,
    ChooseAccountingProductAndAreas,
    EditTaxId
  },
  data() {
    return {
      // areaInterestId: "mMEPxUuPnE",
      // quotationId: "FywmaiIp9I",
      customerType: '',
      market: null,
      formData: {},
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        maxDiscountPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        texId: value => value?.length == 0 || value?.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        numbersOnly: value => !value || /^\d+$/.test(value) || this.$t('validate.numbers_only'),
      },
      isLoading: false,
      menuDate: false,
      menuDueDate: false,
      tempFormData: null,
      isSaving: false,
      isError: false,
      isSuccess: false,
      isDialogAccountingProduct: false,
      isConfirmDialog: false,
      tempInvoice: null,
      tempReceipt: null,
      project: null,
      market: null,
      quotationAreas: [],
      quotationDate: this.$moment().toISOString(),
      quotationDueDate: this.$moment()
        .add(7, "days")
        .toISOString(),
      isEdit: false,
      isCanEdit: false,
      isPrintDialog: false,
      isMessageTemplateDialog: false,
      isAddItemAreasDialog: false,
      taxWithheldOptions: [
      {
          name: this.$t('no'),
          value: 0
        },
        {
          name: "0.75%",
          value: 0.75
        },
        {
          name: "1%",
          value: 1
        },
        {
          name: "1.5%",
          value: 1.5
        },
        {
          name: "2%",
          value: 2
        },
        {
          name: "3%",
          value: 3
        },
        {
          name: "5%",
          value: 5
        },
        {
          name: "10%",
          value: 10
        },
        {
          name: "15%",
          value: 15
        }
      ],
      creditTerm: 7
    };
  },
  computed: {
    ...mapState({
      quotation: state => state.quotation.quotation,
      areaInterest: state => state.areaInterest.areaInterest,
      accountingProducts: state => state.accountingProducts.accountingProducts,
      areaAccountingProducts: state =>
        state.areaAccountingProduct.areaAccountingProducts
    }),
    accountingProductOptions() {
      let _accountingProducts =
        this.accountingProducts?.map(d => {
          return {
            text: `${d.name}`,
            value: `${d.name}`,
            obj: d
          };
        }) || [];
      if (
        this.admin ||
        (this.employee && this.employee.enableAddAccountingProduct)
      )
        _accountingProducts.push({ isAddProduct: true });
      return _accountingProducts;
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    userFullName() {
      if (this.quotation) {
        if (this.quotation.createdByFullName)
          return this.quotation.createdByFullName;
        else return `${this.user.firstName || ""} ${this.user.lastName || ""}`;
      } else {
        return `${this.user.firstName || ""} ${this.user.lastName || ""}`;
      }
    },
    isChange() {
      return JSON.stringify(this.formData) !== this.tempFormData;
    },
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
    admin() {
      return this.$store.getters["admin/getByMarketId"](
        this.$route.params.marketId
      );
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](
        this.$route.params.marketId
      );
    },
    isWht() {
      return this.formData.items.filter(d => d.whtPercent > 0).length > 0;
    },
    isErrorCreditTerm() {
      if (
        this.$moment(this.quotationDueDate)
          .endOf("day")
          .diff(this.$moment(this.quotationDate).endOf("day"), "days") !=
        this.creditTerm
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  async created() {
    this.isLoading = true;
    try {
      if (this.admins && this.admins.length) {
        this.project = this.admins[0].project;
      }
      if (this.employees && this.employees.length) {
        this.project = this.employees[0].project;
      }
      await this.initData();
      await this.$store.dispatch(
        "accountingProducts/getAccountingProducts",
        this.projectId
      );
      if (
        this.quotation &&
        this.quotation.items &&
        this.quotation.items.length
      ) {
        let productIdList = [
          ...new Set([
            ...this.quotation.items
              .filter(
                d =>
                  d.accountingProduct &&
                  this.accountingProducts.findIndex(
                    i => i.objectId === d.accountingProduct.objectId
                  ) == -1
              )
              .map(x => x.accountingProduct.objectId)
          ])
        ];
        await this.$store.dispatch(
          "accountingProducts/getAccountingProductsByIds",
          productIdList
        );
      }
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.isError = true;
    }
  },
  methods: {
    async initData() {
      try {
        let billingData = {
          name: "",
          address: "",
          taxId: "",
          branchName: "",
          tel: "",
          email: ""
        };
        if (this.type == "area-interest" && this.areaInterestId) {
          await this.$store.dispatch("areaInterest/getAreaInterest", {
            id: this.areaInterestId
          });
          this.market = await Market.getMarket(
            this.areaInterest.market.objectId
          );
          if (this.market && this.market.creditTerm) {
            this.creditTerm = this.market.creditTerm;
          }

          if (this.areaInterest.status == "pending") {
            this.isCanEdit = true;
          }

          if (this.areaInterest.isNewCustomer) {
            if (this.areaInterest.customerType == "company") {
              billingData.name = `${this.areaInterest.customerCompanyName || ""}`;
            } else {
              billingData.name = `${this.areaInterest.customerFirstName || ""} ${this.areaInterest.customerLastName || ""}`;
            }
            billingData.tel = this.areaInterest.customerTel;
            billingData.taxId = this.areaInterest.customerCitizenId;
            this.customerType = this.areaInterest.customerType
          } else if (this.areaInterest.customer) {
            this.customerType = this.areaInterest.customer.type
            let customer = new Customer(this.areaInterest.customer);
            billingData.name = customer.fullName;
            billingData.address = customer.fullAddress;
            billingData.taxId = customer.citizenId;
            if (customer.type == "company") {
              billingData.branchName = `${customer.companyBranchName ? customer.companyBranchName : ""
                }${customer.companyBranchName && customer.companyBranchCode
                  ? " "
                  : ""
                }${customer.companyBranchCode ? customer.companyBranchCode : ""}`;
            }
            billingData.tel = customer.tels.join(",");
            billingData.email = customer.emails.join(",");
          }
        }

        if (this.quotationId || this.formData.objectId) {
          await this.$store.dispatch(
            "quotation/getQuotation",
            this.quotationId || this.formData.objectId
          );
          this.formData = this.quotation;
        } else {
          this.isEdit = true;
          this.formData = new Quotation({
            customerData: billingData,
            items: [],
            date: { iso: this.$moment().toISOString() },
            dueDate: {
              iso: this.$moment()
                .add(this.creditTerm, "days")
                .toISOString()
            },
            isVatInclusive: this.project ? this.project.isVatInclusive : false
          });
        }
        if (this.formData.date)
          this.quotationDate = this.$moment(this.formData.date).toISOString();
        if (this.formData.dueDate)
          this.quotationDueDate = this.$moment(
            this.formData.dueDate
          ).toISOString();

        this.quotationAreas = [];
        if (this.areaInterest && this.areaInterest.areas) {
          for (let area of this.areaInterest.areas) {
            if (
              area &&
              this.quotationAreas.findIndex(d => d.objectId == area.objectId) ==
              -1
            ) {
              this.quotationAreas.push(area);
            }
          }
        }
        await this.$store.dispatch(
          "areaAccountingProduct/getAreaAccountingProductByAreas",
          this.quotationAreas.map(d => d.objectId)
        );
        this.tempFormData = JSON.stringify(this.formData);
      } catch (error) {
        throw error;
      }
    },
    onChangeIsVatInclusive() {
      for (let item of this.formData.items) {
        item.setMainIsVatInclusive = this.formData.isVatInclusive;
      }
    },
    preparePostData() {
      let postData = {};
      postData.id = this.formData.objectId;
      postData.areaInterestId = this.areaInterestId;
      postData.customerData = this.formData.customerData || {};
      postData.type = this.documentType || 1;
      postData.items = this.formData.items.map(d => {
        let obj = {};
        if (d.area) {
          if (!d.area.isRemove) {
            obj.area = d.area;
          }
        }
        if (d.meter) obj.meter = d.meter;
        if (d.accountingProduct) obj.accountingProduct = d.accountingProduct;
        obj.name = d.name;
        obj.detail = d.detail;
        obj.unit = d.unit;
        obj.quantity = d.quantity;
        obj.originalPricePerUnit = d.originalPricePerUnit;
        obj.sellVatType = d.sellVatType;
        obj.whtPercent = d.whtPercent;
        obj.totalValue = d.totalValue;
        obj.totalVatValue = d.totalVatValue;
        obj.totalNonVatValue = d.totalNonVatValue;
        obj.totalWhtValue = d.totalWhtValue;
        obj.type = d.type;
        obj.discountType = d.discountType;
        obj.discountPerUnit = d.discountPerUnit;
        obj.originalDiscountPerUnit = d.originalDiscountPerUnit;
        obj.totalDiscountValue = d.totalDiscountValue;
        obj.totalDiscountVatValue = d.totalDiscountVatValue;
        obj.totalDiscountNonVatValue = d.totalDiscountNonVatValue;
        return obj;
      });
      postData.totalValue = this.formData.totalValue;
      postData.totalVatValue = this.formData.totalVatValue;
      postData.totalNonVatValue = this.formData.totalNonVatValue;
      postData.totalVatItemsValue = this.formData.totalVatItemsValue;
      postData.totalNonVatItemsValue = this.formData.totalNonVatItemsValue;
      postData.totalWhtValue = this.formData.totalWhtValue;
      postData.totalDiscountValue = this.formData.totalDiscountValue;
      postData.totalDiscountVatValue = this.formData.totalDiscountVatValue;
      postData.totalDiscountNonVatValue = this.formData.totalDiscountNonVatValue;
      postData.isVatInclusive = this.formData.isVatInclusive;
      postData.currencyCode = this.formData.currencyCode;
      postData.note = this.formData.note;
      postData.date = this.quotationDate
        ? this.$moment(this.quotationDate)
          .startOf("day")
          .toDate()
        : null;
      postData.dueDate = this.quotationDueDate
        ? this.$moment(this.quotationDueDate)
          .endOf("day")
          .toDate()
        : null;
      return postData;
    },
    async saveQuotation() {
      if (this.$refs.form.validate() && !this.formData.items.find(d => this.isDuplicateItem(d))) {
        this.isSaving = true;
        try {
          let postData = this.preparePostData();
          if (this.formData.objectId) {
            await this.$store.dispatch("quotation/updateQuotation", postData);
          } else {
            let { objectId } = await this.$store.dispatch(
              "quotation/createQuotation",
              postData
            );
            this.formData.objectId = objectId;
          }

          await this.$store.dispatch("quotation/sendQuotation", {
            id: this.formData.objectId,
            date: this.$moment(this.quotationDate)
              .startOf("day")
              .toDate(),
            dueDate: this.$moment(this.quotationDueDate)
              .endOf("day")
              .toDate()
          });

          await this.initData();
          this.$emit("onSaveSuccess", this.quotation);

          this.isSaving = false;
          this.isSuccess = true;
          this.isEdit = false;
          return true;
        } catch (error) {
          this.isSaving = false;
          this.isError = true;
        }
      }
    },
    deleteItem(index) {
      this.formData.items.splice(index, 1);
    },
    addItem() {
      this.formData.items.push(
        new DocumentItem(
          { area: { isRemove: true, name: "-" } },
          this.formData.isVatInclusive,
          this.formData.vatPercent
        )
      );
    },
    chooseItem(product, index) {
      this.formData.items[index].quantity = 1;
      this.formData.items[index].name = product.name;
      this.formData.items[index].unit = product.unit;
      this.formData.items[index].sellVatType = product.sellVatType;
      this.formData.items[index].whtPercent = 0;
      this.formData.items[index].type = product.type;
      this.formData.items[index].discountType = 1;
      if (product.type == "discount") {
        this.formData.items[index].originalPricePerUnit = 0;
      }
      if (
        (this.areaInterest.customer && this.areaInterest.customer.type == "company") ||
        (this.areaInterest.customerType == "company")
      ) {
        if (this.market && this.market.disableWht) {
          this.formData.items[index].whtPercent = 0;
        } else {
          this.formData.items[index].whtPercent = product.whtPercent || 0;
        }
      } else {
        this.formData.items[index].whtPercent = 0;
      }
      if (
        this.formData.items[index].area &&
        !this.formData.items[index].area.isRemove
      ) {
        let area = this.formData.items[index].area;

        let areaAccountingProduct = this.areaAccountingProducts.find(
          d =>
            d.area.objectId == area.objectId &&
            d.accountingProduct.objectId == product.objectId
        );

        if (areaAccountingProduct) {
          this.formData.items[index].originalPricePerUnit =
            areaAccountingProduct.cost || 0;
          this.formData.items[index].discountPerUnit =
            areaAccountingProduct.discount || 0;
          this.formData.items[index].discountType =
            areaAccountingProduct.discountType || 0;
        }
      }
      if (product.objectId) {
        this.formData.items[index].accountingProduct = {
          className: "AccountingProduct",
          objectId: product.objectId,
          __type: "Pointer"
        };
      }
    },
    chooseArea(index) {
      if (
        this.formData.items[index].accountingProduct &&
        !this.formData.items[index].area.isRemove
      ) {
        let area = this.formData.items[index].area;
        let accountingProduct = this.formData.items[index].accountingProduct;

        let areaAccountingProduct = this.areaAccountingProducts.find(
          d =>
            d.area.objectId == area.objectId &&
            d.accountingProduct.objectId == accountingProduct.objectId
        );

        if (areaAccountingProduct) {
          this.formData.items[index].originalPricePerUnit =
            areaAccountingProduct.cost || 0;
          this.formData.items[index].discountPerUnit =
            areaAccountingProduct.discount || 0;
          this.formData.items[index].discountType =
            areaAccountingProduct.discountType || 0;
        }
      }
    },
    addTels() {
      this.formData.tels.push("");
    },
    addEmails() {
      this.formData.emails.push("");
    },
    dismiss() {
      if (this.isChange) this.isConfirmDialog = true;
      else this.$emit("onDismiss", true);
    },
    addProduct() {
      this.isDialogAccountingProduct = true;
    },
    async onOkConfirmDialog() {
      this.isConfirmDialog = false;
      try {
        let d = await this.saveQuotation();
        if (d) this.$emit("onDismiss", true);
      } catch (err) { }
    },
    onCancelConfirmDialog() {
      this.$emit("onDismiss", true);
    },
    onChangeDate() {
      this.quotationDueDate = this.$moment(this.quotationDate)
        .add(this.creditTerm, "days")
        .toISOString();
      this.menuDate = false;
    },
    onSelectMessage(content) {
      this.formData.note += content;
    },
    onSuccessChooseProductAndAreas(data) {
      for (let area of data.areas) {
        this.formData.items.push(
          new DocumentItem(
            { area: area },
            this.formData.isVatInclusive,
            this.formData.vatPercent
          )
        );
        this.chooseItem(data.accountingProduct, this.formData.items.length - 1);
      }
    },
    isDuplicateItem(item) {
      if (item.accountingProduct && item.area) {
        return this.formData.items
          .filter(d => d.accountingProduct?.objectId == item.accountingProduct?.objectId && d.area?.objectId == item.area?.objectId)
          .length > 1
      }
    },
    onWriteData(dataTax) {
      if (this.customerType == 'company' && dataTax) {
        this.formData.customerData.name = dataTax.companyName
        this.formData.customerData.address = dataTax.fullAddress
        // this.$forceUpdate();
        // this.form.addressStreet = dataTax.addressStreet;
        // this.form.addressSubDistrict = dataTax.Thambol;
        // this.form.addressDistrict = dataTax.Amphur;
        // this.form.addressProvince = dataTax.Province;
        // this.form.addressZipcode = dataTax.PostCode;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}

.tool-bar {
  position: fixed;
  height: 70px;
  background-color: rgb(0, 166, 80);
  color: white;
}

.table-item.header {
  background-color: rgb(0, 166, 80);

  th {
    color: white !important;
    font-size: 15px;
  }
}

.summary-topic {
  margin: 5px 0;
  color: rgb(0, 166, 80);
  font-weight: 400;

  &.bold {
    font-weight: 600;
  }
}

.summary-number {
  margin: 5px 0;
  font-weight: 500;

  &.bold {
    font-weight: 700;
  }
}

.rounded-t {
  border-radius: 15px 15px 0 0 !important;
}

.rounded-b {
  border-radius: 0 0 15px 15px !important;
}

.rounded-none {
  border-radius: 0 !important;
}

.vertical-top {
  vertical-align: top !important;
}

.card-receipt-form {
  height: calc(100vh - 135px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>